/* @flow */

import { Component } from "react";
import type { FileDescriptor, FileUploadStatus, Action, UIState } from "../../../types";

export type DocumentCollectionStepProps = {
  documents: FileDescriptor[],
  onSuccess: (documents: FileDescriptor[]) => void,
  dispatch: Action => Action,
  ui: UIState,
  countryCode: string
};

type DocumentCollectionStepState = {
  documents: FileDescriptor[]
};

export class DocumentCollectionStep extends Component<
  DocumentCollectionStepProps,
  DocumentCollectionStepState
> {
  constructor(props: DocumentCollectionStepProps) {
    super(props);

    this.state = {
      documents: props.documents
    };
  }

  handleFileCollectionAdd = (newFile: FileDescriptor) => {
    this.setState({
      documents: this.state.documents.concat(newFile)
    });
  };

  handleFileCollectionRemove = (fileToRemove: FileDescriptor) => {
    this.setState({
      documents: this.state.documents.filter(({ id }) => id !== fileToRemove.id)
    });
  };

  handleFileUploadStatusChange = (status: FileUploadStatus) => {
    if (status === "uploading") {
      this.props.dispatch({ type: "UI_CONTACT_DOCUMENT_UPLOAD_START" });
    } else if (status === "complete") {
      this.props.dispatch({ type: "UI_ASYNC_ACTION_COMPLETE" });
    }
  };

  commitDocuments = () => {
    this.props.onSuccess(this.state.documents);
  };
}
